/**
 * @flow
 */

declare var gtag;
declare var dataLayer;
declare var mp_track;

export type GAData =
    {
        category: 'Acquire';
        action: 'SignupWithContent' | 'LoginWithContent' | 'SignUpFail' | 'LoginError' | 'OpenSignUp'
            | 'FillSignUp' | 'CloseSignUp' | 'OpenLogin' | 'FillLogin' | 'CloseLogin' | 'CloseCTA';
        value?: string;
    } |
    {
        category: 'Content';
        action: 'ViewProcess' | 'ViewStory' | 'ViewTOC' | 'CloseTOC' | 'NavigateStory';
        value?: string;
    } |
    {
        category: 'Feedback';
        action: 'SubmitFeedback' | 'ContributeSubmit' | 'PartnershipSubmit' | 'OpenFeedback' | 'CloseFeedback'
            | 'OpenContribute' | 'CloseContribute' | 'OpenPartnership' | 'ClosePartnership';
        value?: string;

    }
export type MPEvent = 'ST Signup' | 'ST Login' | 'ST Visit';

export function GA(data: GAData) {
    const {category, action, value} = data;
    if (__DEV__) {
        console.info('analytics::ga', {category, action, value});
    } else {
        if (dataLayer)
            dataLayer.push({'event': action, category, value});
        else if (gtag)
            gtag('event', action, {category, value});
        else
            console.warn('analytics::ga', 'no dataLayer or gtag');
        //gtag('event', action, {category, value});
    }
}

export function MP(data: MPEvent, endPoint: string) {
    const d = {'story': endPoint};
    if (__DEV__) {
        console.info('analytics::mp_track', {event: data, data: d});
    } else {
        if(mp_track)
            mp_track(data, d);
        else
            console.warn('analytics::mp_track', 'no mp_track');
    }
}



// WEBPACK FOOTER //
// ./src/lib/analytics.js